export const breakpoints = {
  tablet: 768,
  desktop: 1024,
  largeDesktop: 1280,
}
